// extracted by mini-css-extract-plugin
export var errorInput = "bl_dS";
export var errorLabel = "bl_dR";
export var inputContainer = "bl_dL";
export var inputNumber = "bl_dN";
export var inputPercentage = "bl_dP";
export var textInput = "bl_dQ";
export var textInputDefault = "bl_dT";
export var textlabel = "bl_dM";